import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createSelector } from '@reduxjs/toolkit';
import React from 'react';
import { JSONTree } from 'react-json-tree';
import { getJsonTreeTheme, StyleUtilsContext } from '../styles/themes.js';
import { getItemString, labelRenderer } from '../styles/tree.js';
import { identity } from '../utils/object.js';
export class TreeView extends React.PureComponent {
    constructor(props) {
        super(props);
        this.selectTheme = createSelector(identity, getJsonTreeTheme);
    }
    render() {
        const { data, before, after, children, keyPath, shouldExpandNodeInitially, hideRoot, rootProps, } = this.props;
        return (_jsx(StyleUtilsContext.Consumer, { children: ({ invertTheme, base16Theme }) => {
                return (_jsxs("div", { ...rootProps, css: {
                        overflowX: 'auto',
                        overflowY: 'auto',
                        padding: '0.5em 1em',
                    }, children: [before, _jsx(JSONTree, { keyPath: keyPath, shouldExpandNodeInitially: shouldExpandNodeInitially, data: data, labelRenderer: labelRenderer, theme: this.selectTheme(base16Theme), invertTheme: invertTheme, getItemString: getItemString, hideRoot: hideRoot }), after, children] }));
            } }));
    }
}
TreeView.defaultProps = {
    hideRoot: true,
    shouldExpandNodeInitially: (keyPath, value, layer) => {
        return layer < 2;
    },
};
